import { Fragment } from 'react/jsx-runtime';
import { ReactComponent as ApprovedIcon } from '../../assets/icons/approved-icon.svg';
import { ReactComponent as RefusedIcon } from '../../assets/icons/refused-icon.svg';
import { ReactComponent as ReplacedIcon } from '../../assets/icons/replaced-icon.svg';
import { Document, Model3d } from '../../models/models';

// Funzione generica per ottenere l'icona dello stato
const getStatusIcon = (statusKey: string) => {
    switch (statusKey) {
        case 'rejected':
            return <RefusedIcon />;
        case 'approved':
            return <ApprovedIcon />;
        case 'replaced':
            return <ReplacedIcon />;
        default:
            return null;
    }
};

export const AttachmentStatusIcon = ({ document }: { document: Document }) => {
    return <Fragment>{getStatusIcon(document.status.key)}</Fragment>;
};

export const Model3dIcon = ({ model3d }: { model3d: Model3d }) => {
    return <Fragment>{getStatusIcon(model3d.status.key)}</Fragment>;
};
